import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Emty from "../../components/Emty/Emty";
import useGetPost from "../../hooks/UseGetPost";
import { NoticeListInter } from "../../interface/interface";
import "./css/index.css";

const bbs_id = 3;

/** 공지사항 리스트 페이지 */
function Notice() {
  const navigate = useNavigate();
  const [Delete, setDelete] = useState<number | undefined>(undefined);
  const [search, setsearch] = useState<string>("");
  const [data, PostRemove, PagingUpdate, PostSearch] = useGetPost({ bbs_id });

  const NavWriteNotice = useCallback(() => {
    navigate("/new/notice", {
      state: {
        status: "new",
      },
    });
  }, [navigate]);

  const NavFixNotice = useCallback(
    (data: NoticeListInter) => {
      navigate("/new/notice", {
        state: {
          status: "fix",
          data,
        },
      });
    },
    [navigate]
  );

  const __searchInit = useCallback(() => {
    //hook 분리 예정
  }, []);

  return (
    <main className="notice-page">
      <div className="wrapper">
        <div className="title">
          <div className="left">
            <p>공지사항 관리</p>
          </div>
          <form
            className="right"
            onSubmit={(e) => {
              PostSearch(search);
              e.preventDefault();
            }}
          >
            <div className="search_box">
              <input
                type="text"
                className="search-input"
                placeholder="공지사항 검색"
                onChange={(e) => {
                  setsearch(e.target.value);
                }}
              ></input>
              <img className="search" src="/assets/common/search.svg" />
            </div>
            <button
              className="search-btn"
              onClick={() => {
                PostSearch(search);
              }}
              id="submit"
            >
              검색
            </button>
            <button className="insert-notice" onClick={NavWriteNotice}>
              공지사항 추가
            </button>
          </form>
        </div>
        {data.length > 0 ? (
          <React.Fragment>
            <div className="sub">
              <div className="menu">
                <div className="name1">게시글명</div>
                <div className="name2">삭제하기</div>
              </div>
            </div>
            <div className="list">
              {data.map((item, index) => {
                return (
                  <div key={index} className={`box `}>
                    <div className="name">{item.ctts_tit}</div>
                    <button
                      className="fix-btn"
                      onClick={() => {
                        NavFixNotice(item);
                      }}
                    >
                      수정하기
                    </button>
                    <div className={`img-wrapper`}>
                      <img
                        src="/assets/common/delete.svg"
                        alt="삭제"
                        onClick={() => {
                          setDelete(index);
                        }}
                      />
                    </div>
                    <div
                      className={`delete ${
                        Delete === index ? "delete-active" : ""
                      }`}
                    >
                      <div className="title">삭제하시겠습니까?</div>
                      <button
                        className="deleteBox"
                        onClick={() => {
                          PostRemove(
                            {
                              ctts_tit: item.ctts_tit,
                              ctts_ctts: item.ctts_ctts,
                            },
                            item.ctts_id
                          );
                          setDelete(undefined);
                        }}
                      >
                        삭제하기
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        ) : (
          <Emty />
        )}
      </div>
    </main>
  );
}

export default Notice;
